var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9902 23.4095C5.07191 24.5878 1 27.0134 1 29.8237C1 33.7748 9.03582 36.9796 18.9668 36.9996C28.8978 36.9796 36.9336 33.7748 36.9336 29.8229C36.9336 27.0134 32.8609 24.5878 26.9434 23.4087M18.5172 7.39942C18.5196 7.39942 18.5212 7.39942 18.5236 7.39942C18.5236 7.39942 18.5276 7.39942 18.53 7.39942C20.7388 7.39622 22.5299 9.18418 22.5339 11.3937C22.5371 13.6033 20.75 15.396 18.542 15.3992C18.5356 15.3992 18.53 15.3984 18.5244 15.3984C18.518 15.3984 18.5124 15.3992 18.5068 15.3992C16.2989 15.396 14.5109 13.6033 14.5141 11.3937C14.5173 9.18418 16.3093 7.39622 18.5172 7.39942Z",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5346 1C24.2784 1 28.9343 5.6559 28.9343 11.3998C28.9375 13.8845 28.5687 15.6061 27.1568 17.8652C25.7456 20.1228 18.5346 30.5993 18.5346 30.5993C18.5346 30.5993 11.3235 20.1228 9.91235 17.8652C8.50038 15.6061 8.13159 13.8845 8.13479 11.3998C8.13479 5.6559 12.7907 1 18.5346 1Z",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon1);
export default __webpack_public_path__ + "static/media/contacts-icon1.d717c1030df5071ec5ed929ff8dbfeed.svg";
export { ForwardRef as ReactComponent };